























































import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
    components: {}
})
export default class MediaDownloadImageItem extends Vue {
    [x: string]: any;
    @Prop()
    imageData!: any;
}
